// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3B3NH","head":"Table_head__1wJtY","col":"Table_col__h-wCJ"};